<span *ngIf="fields">
  <span *ngFor="let field of fields ; let first = first; let last = last">
    <span *ngIf="!first && !last">,</span>
    <span *ngIf="!first && last"> and </span>
    a <strong [matTooltip]="getFieldDescription(field)">{{getFieldName(field)}}</strong>
  </span>
</span>
